import React,{Component} from "react"
import { Form,  } from 'antd';
import { Upload,Input, message, Button, Icon } from 'antd';
import { config } from "../../../../../config/fbConfig";

export default class Lecturefiles extends Component{
    constructor(props){
        super(props);
        this.state = {
            files:[],
            disabled:false,
           
        }
    }
    data = (file)=>{
        return {
        projectId: config.projectId,
        destination: `files/${this.props.profile.uid}/${file.name}`
    }}
    onChange = (info)=> {
        const {uploadFile,removeFile,sectionIndx,lectureIndx,profile} = this.props
        const { status } = info.file;
        if (status === 'done') {
        var {name,timeCreated,mediaLink} = info.file.response;
        var {uid} =profile
        var fileData = {
          name:name.split('/')[2],url:mediaLink,status:'done',uid:info.file.uid
        }
        uploadFile({fileData,sectionIndx,lectureIndx})
        message.success(`${info.file.name} file uploaded successfully.`);
        } else if(status === "removed"){
            removeFile({fileData:info.file,sectionIndx,lectureIndx})
        }
         else  if (info.file.status !== 'uploading') {
        //    removeFile({fileData:info.file,sectionIndx,lectureIndx})
          } else if (status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      }
    toggleFilesUpload = () => this.setState({disabled:!this.state.disabled})
 
    render(){
        const {showUpLoadFileForm,getFieldDecorator,lectureId,files} = this.props
        const props = {
            accept:".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf",
            action:'https://orsityfileserver.herokuapp.com/fileupload',          
            data:this.data,
            onChange:this.onChange,
            multiple :true,
            defaultFileList:files
      };
        return(
            <div>
                <div className="btn-holder">
                <Form.Item label="Upload Lecture Files">
                </Form.Item>
                
                </div>
                <Upload {...props}>
                    <Button>
                    <Icon type="upload" /> Upload lecture files
                    </Button>
                </Upload>
        {/* {
          this.state.disabled ? <div className="lecfile-upload">
            <Form.Item label="File name">
              {getFieldDecorator('filename1', {
                rules: [{ required: true, message: 'Please input file name!' }],
              })(
                <Input
                  name="filename"
                  placeholder="filename"
                />,
              )}
            </Form.Item>
            <Upload {...this.props}>
                <Button>
                <Icon type="upload" /> Click to Upload
                </Button>
            </Upload>
            <div className="controls">
             
              <Button type="danger" className="cancel-btn" onClick={()=> this.toggleFilesUpload()}>
                Remove File
              </Button>
            </div>
          </div> : null
        } */}
        
            </div>
        )
    }
}
